import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import {
  displaySDFInfo,
  getMissingSDFDisplay,
  paintSaveAndNextButton
} from '../../shared/UtilFunctions';

export default function SourcingDiversityFormStep(props) {
  const { strategyProps, showSaveButton, strategyInformation } = props;
  const { hasUSScope, okToPublish } = strategyProps;

  function getLocalMissingSDFDisplay() {
    return getMissingSDFDisplay(hasUSScope, strategyInformation, okToPublish);
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Grid container alignItems="flex-start">
        <Grid size={{ sm: 6, xs: 12 }}>
          {displaySDFInfo(
            hasUSScope,
            strategyInformation,
            false,
            true,
            getLocalMissingSDFDisplay
          )}

          {paintSaveAndNextButton(
            showSaveButton && !strategyInformation?.sdsFormId // Save button should be only shown if the SDS Form Id is not there
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
